export default "__VITE_ASSET__ef966653__"